// extracted by mini-css-extract-plugin
export var markdown = "_s5-0";
export var tableWrapper = "_s5-1";